/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Typography from './Typography';

import styles from '../../styles/typography/header-title.module.css';

const propTypes = {
    tag: PropTypes.string,
    brand: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    tag: 'h1',
    brand: null,
    className: null,
};

function HeaderTitle({ tag, brand, className, ...props }) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [styles[brand]]: className !== null,
                    [className]: className !== null,
                },
            ])}
            {...props}
        />
    );
}

HeaderTitle.propTypes = propTypes;
HeaderTitle.defaultProps = defaultProps;

export default HeaderTitle;
